import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { useStaticQuery, graphql } from "gatsby";
import "./header.css";

import { Fab, Drawer, TextField, Hidden } from "@material-ui/core";
import ContactCard from "../components/contact-card";
import Close from "@material-ui/icons/Close";
import Search from "@material-ui/icons/Search";
import Menu from "@material-ui/icons/Menu";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

import styled from "styled-components";
//Images
import SearchIcon from "../images/search.svg";

const FabButton = withStyles((theme) => ({
  root: {
    width: 45,
    height: 45,
    [theme.breakpoints.down(770)]: {
      boxShadow: theme.shadows[3],
    },
  },
}))(Fab);

const HeaderWrapper = styled.header`
  height: 70px;
  text-align: center;
  @media (min-width: 1020px) {
    height: 80px;
  }
`;
const Nav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 9;
  width: 100vw;
  height: 70px;
  position: fixed;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.16);
  @media (min-width: 1020px) {
    justify-content: space-between;
    height: 80px;
  }
`;
const NavDiv = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1380px;
  margin: auto;
  width: 100%;
  align-items: center;
`;
const Nav__left = styled.div`
  padding-left: 100px;
  position: relative;
  z-index: 99;
  @media (max-width: 770px) {
    padding-left: 20px;
  }
`;
const Nav__center = styled.div`
  padding: 5px;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  @media (max-width: 770px) {
    padding-left: 0;
  }
`;
const Nav__right = styled.div`
  padding-right: 100px;
  position: relative;
  z-index: 99;
  @media (max-width: 900px) {
    padding-right: 20px;
    display: flex;
    flex-direction: row-reverse;
  }
`;
const Nav__logo = styled(ImageLibpixel)`
  max-width: 60px;
  max-height: 60px;
  @media (min-width: 1180px) {
    max-width: 75px;
    max-height: 75px;
  }
`;
const Nav__right__menu = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
  }
`;
const Nav__right__search = styled(ImageLibpixel)`
  width: 16px;
  object-fit: contain;
`;
const FullList = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f7f7f7;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.41);
  z-index: 99;
`;
const FullList__close = styled.button`
  margin: 16px;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 34px;
  height: 34px;
  @media (max-width: 900px) {
    background-color: transparent;
  }
  svg {
    font-size: 2rem;
    color: #333;
  }
`;
const MobileUl = styled.ul`
  text-align: left;
  padding: 40px 10px;
  margin-bottom: 0;
`;
const MobileLi = styled.li`
  padding: 10px 0;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const OpenMobileUlUl = styled.button`
  background-color: #f7f7f7;
  color: #1b2636;
  border: 1px solid #bdbdbd;
  border-radius: 56px;
  margin: 0 15px;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const MobileUlUl = styled.ul`
  height: 0;
  overflow: hidden;
  transition: all 0.4s ease-in-out;
  margin: 0;

  li {
    margin: 0;
    padding: 10px 20px;
    &:before {
      content: "-";
    }
  }
  &.open {
    height: 130px;
  }
`;
const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px 50px 30px;
  justify-content: flex-start;
  @media (max-width: 940px) {
    height: 100%;
    min-height: 100vh;
  }
`;
const SearchContainer = styled.div`
  display: flex;
  margin-top: 60px;
  padding: 0 20px;
  @media (max-width: 940px) {
    padding: 0;
  }
`;
const SearchField = styled((props) => <TextField {...props} />)`
  justify-content: center;
  margin-bottom: 50px;
  width: 320px;
  color: #1b2636;
  background-color: #fff;
  position: relative;
  z-index: 9999;
  @media (max-width: 770px) {
    width: 280px;
  }
`;
const SearchButton = styled((props) => <Link {...props} />)`
  background-color: #fff;
  color: #1b2636;
  border: 1px solid #bdbdbd;
  border-radius: 56px;
  margin: 0 15px;
  width: 80px;
  height: 56px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: #f15e4e;
    border: 1px solid #f15e4e;
  }
  &:hover svg {
    color: #fff;
  }
  &.disabled {
    pointer-events: none;
  }
  @media (max-width: 900px) {
    width: 70px;
  }
`;
const DesktopLinks = styled((props) => <Link {...props} />)`
  padding: 0 25px;
  color: #000;
  &:hover {
    text-decoration: underline;
  }
`;
const SideList__close = styled.button`
  cursor: pointer;
  margin: 8px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 5px;
  right: 0;
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 24px;
  color: #f15e4e;
  background-color: #fff;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover {
    background-color: rgb(0 0 0 / 5%);
  }
`;
const Header__adress = styled.div`
  padding: 20px 0;
`;
const SideListTitle = styled.h4`
  margin-bottom: 5px;
  margin-left: 0;
  margin-top: 0;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SideListTitleBox = styled.div`
  margin-bottom: 0;
  margin-left: 0;
  margin-top: 0;
  padding-bottom: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const SideListButton = styled((props) => <Link {...props} />)`
  width: 100%;
  max-width: 65px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-radius: 50px;
  padding: 0 0 2px 0;
  margin-bottom: 5px;
  position: absolute;
  right: -10px;
  top: 0;
  background-color: #fff;
  border: 0.6px solid #bdbdbd;
  box-shadow: none;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover {
    box-shadow: none;
    text-decoration: none !important;
    background-color: rgb(0 0 0 / 5%);
  }
`;
const UnderlineShort = styled.hr`
  border-bottom: 0.2px solid #bdbdbd;
  width: 100%;
`;
const UnderlineLong = styled.hr`
  border-bottom: 0.2px solid #bdbdbd;
  width: 85%;
`;
const ServiceDropdown = styled.div`
  overflow: hidden;
  transition: 0.3s all ease-in;
  &:hover div {
    max-height: 550px;
  }
`;
const DesktopLinksService = styled.div`
  padding: 0 25px;
  display: flex;
  cursor: pointer;
`;
const ServiceDropdownContainer = styled.div`
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  z-index: 9;
  width: 100%;
  top: 70px;
  margin-top: 10px;
  left: 0px;
  background-color: #fff;
  max-height: 0;
  box-shadow: 0px 6px 7px 0px rgba(0, 0, 0, 0.05);
  transition: 0.5s max-height ease-in;
`;
const ServiceColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 235px;
  margin: 0 40px;
  padding-top: 10px;
`;
const ServiceBoxLabelContainer = styled((props) => <Link {...props} />)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 17px;
  width: 235px;
  text-decoration: none;
  text-align: left;
  &:hover div {
    width: 100%;
  }
`;
const ServiceBoxLabelLine = styled.div`
  border-bottom: 2px solid #333;
  width: 60px;
  transition: all 0.3s ease-in-out;
  text-align: left;
`;
const ServiceBoxLabel = styled.h3`
  text-transform: uppercase;
  font-weight: 300;
  margin: 0 0 10px 0;
  pointer-events: none;
  font-size: 1.1rem;
  font-family: "Poppins";
`;
const ServiceBox = styled((props) => <Link {...props} />)`
  text-decoration: none;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  width: 290px;
  padding: 10px;
  margin: 7px 0;
  &:hover {
    background-color: #f7f7f7;
  }
`;
const ServiceBoxIcon = styled(ImageLibpixel)`
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-right: 15px;
`;
const ServiceBoxTitle = styled.h4`
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
  font-family: "Poppins";
`;
const ServiceBoxText = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #747474;
  line-height: 1.5;
  min-height: 43px;
  width: 100%;
  padding-left: 40px;
  text-align: left;
`;
const ServiceLinksMobile = styled((props) => <Link {...props} />)`
  padding-left: 10px;
`;

const Header = () => {
  const {
    wpMenu,
    ansatte,
    wp: { general },
  } = useStaticQuery(graphql`
    fragment HeaderMenuItem on WpMenuItem {
      connectedNode {
        node {
          uri
        }
      }
      label
      url
    }
    query {
      wp {
        general: acfThemeGeneralSettings {
          options: acfThemeOptions {
            address
            logo {
              sourceUrl
            }
            siteTitle
          }
        }
      }
      wpMenu(locations: { eq: MENU_1 }) {
        menuItems {
          nodes {
            childItems {
              nodes {
                childItems {
                  nodes {
                    acfMenuItem {
                      img {
                        sourceUrl
                      }
                      title
                    }
                    ...HeaderMenuItem
                  }
                }
                ...HeaderMenuItem
              }
            }
            parentId
            ...HeaderMenuItem
          }
        }
      }
      ansatte: allWpEmployee(
        filter: {
          featuredImage: { node: { sourceUrl: { ne: null } } }
          databaseId: { in: [178, 176, 169, 441, 167, 147] }
        }
        sort: { menuOrder: ASC }
      ) {
        edges {
          node {
            id
            title
            slug
            uri
            acfEmployee {
              email
              phone
              title
            }
            categories {
              nodes {
                databaseId
                name
              }
            }
            blocks {
              ...GutenbergBlocks
            }
            date(formatString: "MMMM DD, YYYY")
            author {
              node {
                name
              }
            }
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
          }
        }
      }
      localSearchPages {
        index
        store
      }
    }
  `);

  const [state, setState] = React.useState({
    menu: false,
    search: false,
  });

  const [isOpen, openMobileSubmenu] = React.useState(false);
  const [srch, setSearchUrl] = React.useState(_("/sok/"));

  const doSearch = (e) => {
    let onlyLetters = /^[-A-Za-z0-9\u00C0-\u00ff ]+$/.test(e);
    var desktopButton = document.getElementById("searchbutton");

    if (e.length >= 2 && onlyLetters) {
      setSearchUrl(`${_("/sok/")}?s=${e}`);
      desktopButton.classList.remove("disabled");
    } else {
      setSearchUrl(_("/sok/"));
      desktopButton.classList.add("disabled");
    }
  };

  React.useEffect(() => {
    if (state.menu && window.innerWidth < 768) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "";
    }
  }, [state.menu]);

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && event.target.value.length > 2) {
      document.getElementById("searchbutton").click();
    }
  };

  const sideList = () => (
    <div role="presentation">
      <SideList__close onClick={toggleDrawer("search", false)}>
        <Close />
      </SideList__close>
      <MenuContainer>
        <SearchContainer>
          <SearchField
            id="input-with-icon-textfield"
            label={_("Søk")}
            type="search"
            variant="outlined"
            onChange={(event) => doSearch(event.target.value)}
            onKeyDown={handleKeyDown}
          />
          <SearchButton to={srch} id="searchbutton" className="disabled">
            <Search />
          </SearchButton>
        </SearchContainer>
        <Header__adress>
          <SideListTitle>{_("Her finner du oss")}</SideListTitle>
          <UnderlineLong />
          <p id="adressInfo">
            {general.options?.siteTitle}
            <br />
            {general.options?.address}
          </p>
        </Header__adress>
        <div id="employeesContainer">
          <SideListTitleBox>
            <SideListTitle>{_("Ansatte")}</SideListTitle>
            <SideListButton to="/kontakt/">{_("Se alle")}</SideListButton>
          </SideListTitleBox>
          <UnderlineLong />
          {ansatte &&
            ansatte?.edges?.map(({ node }, i) => (
              <div key={i}>
                <ContactCard
                  remoteImg={node.featuredImage?.node?.sourceUrl}
                  name={node.title}
                  jobTitle={node.acfEmployee?.title}
                  number={node.acfEmployee?.phone}
                  email={node.acfEmployee?.email}
                />
                <UnderlineShort />
              </div>
            ))}
        </div>
      </MenuContainer>
    </div>
  );
  function recursiveMobileMenu(items) {
    return items?.map((item, i) =>
      item.childItems?.nodes?.length > 0 ? (
        <>
          <MobileLi key={i} style={{ marginBottom: "5px" }}>
            <Link to={item.connectedNode?.node?.uri || item.url}>
              {item.label}{" "}
            </Link>
            <OpenMobileUlUl onClick={() => openMobileSubmenu(!isOpen)}>
              <KeyboardArrowDownIcon
                style={{
                  transition: "all, .5s ease",
                  transform: isOpen ? "rotate(180deg)" : "",
                }}
              />
            </OpenMobileUlUl>
          </MobileLi>
          <MobileUlUl className={isOpen ? "open" : ""}>
            {item.childItems?.nodes?.map((childItem, index) => (
              <li key={index}>
                <ServiceLinksMobile
                  to={childItem.connectedNode?.node?.uri || childItem.url}
                >
                  {childItem.label}
                </ServiceLinksMobile>
              </li>
            ))}
          </MobileUlUl>
        </>
      ) : (
        <MobileLi key={i}>
          <Link to={item.connectedNode?.node?.uri || item.url}>
            {item.label}
          </Link>
        </MobileLi>
      )
    );
  }

  const fullList = () => (
    <FullList role="presentation">
      <FullList__close onClick={toggleDrawer("menu", false)}>
        <Close />
      </FullList__close>
      <MenuContainer>
        <MobileUl>
          {recursiveMobileMenu(
            wpMenu.menuItems.nodes?.filter((item) => item.parentId === null)
          )}
        </MobileUl>
      </MenuContainer>
    </FullList>
  );
  function menuColumn(item) {
    return (
      <ServiceColumn>
        <ServiceBoxLabelContainer
          to={item.connectedNode?.node?.uri || item.url}
        >
          <ServiceBoxLabel>{item.label}</ServiceBoxLabel>
          <ServiceBoxLabelLine />
        </ServiceBoxLabelContainer>
        {item.childItems?.nodes?.map((child, i) => (
          <ServiceBox key={i} to={child.connectedNode?.node?.uri || child.url}>
            {child.acfMenuItem?.img?.sourceUrl && (
              <ServiceBoxIcon
                src={child.acfMenuItem?.img?.sourceUrl}
                alt={_("tjenste ikon")}
              />
            )}
            <ServiceBoxTitle>{child.label}</ServiceBoxTitle>
            <ServiceBoxText>{child.acfMenuItem?.title}</ServiceBoxText>
          </ServiceBox>
        ))}
      </ServiceColumn>
    );
  }

  function recursiveMenu(items) {
    return items?.map((item, i) =>
      item.childItems?.nodes?.length > 0 ? (
        <ServiceDropdown key={i}>
          <DesktopLinksService>
            {item.label} <KeyboardArrowDownIcon />
          </DesktopLinksService>
          <ServiceDropdownContainer>
            {item.childItems?.nodes?.map((child) => menuColumn(child))}
          </ServiceDropdownContainer>
        </ServiceDropdown>
      ) : (
        <DesktopLinks key={i} to={item.connectedNode?.node?.uri || item.url}>
          {item.label}
        </DesktopLinks>
      )
    );
  }

  const List = () =>
    recursiveMenu(
      wpMenu.menuItems.nodes?.filter((item) => item.parentId === null)
    );

  return (
    <HeaderWrapper>
      <Nav className="specificCLass">
        <NavDiv>
          <Nav__left>
            <Link to="/">
              <Nav__logo
                src={general.options.logo?.sourceUrl}
                alt={_("logotype")}
                width="75"
                height="75"
                data-mode="fit"
              />
            </Link>
          </Nav__left>
          <Nav__center>
            <Hidden smDown>{List()}</Hidden>
          </Nav__center>
          <Nav__right>
            <Nav__right__menu>
              <FabButton
                size="small"
                color="primary"
                aria-label="mobile-menu"
                onClick={toggleDrawer("menu", true)}
                style={{ marginLeft: "1rem" }}
              >
                <Menu />
              </FabButton>
              <Drawer anchor="right" variant="persistent" open={state.menu}>
                {fullList()}
              </Drawer>
            </Nav__right__menu>
            <FabButton
              size="small"
              color="primary"
              aria-label="search"
              onClick={toggleDrawer("search", true)}
            >
              <Nav__right__search
                src={SearchIcon}
                alt={_("search the webpage")}
              />
            </FabButton>
            <Drawer
              anchor="right"
              open={state.search}
              onClose={toggleDrawer("search", false)}
            >
              {sideList("right")}
            </Drawer>
          </Nav__right>
        </NavDiv>
      </Nav>
    </HeaderWrapper>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
  headerColor: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
  headerColor: "page",
};

export default Header;
